import React from 'react';
import Skeleton from 'react-loading-skeleton';

const CardSkeleton = () => {
  return (
    <div className='d-flex flex-wrap gap-3 mt-10'>
{[...Array(9)].map((_, i) => (
    <div className="card" style={{ width: '231px', height: '140px' }}>
      {/* Card Body */}
      <div className="card-body">
        <Skeleton width="80%" height={20} />
        <div className="py-1">
          <Skeleton width="60%" height={25} />
        </div>
      </div>
    </div>
    ))}
    </div>
  );
};

export default CardSkeleton;



<div className='d-flex flex-wrap gap-3 mt-10'>
{[...Array(9)].map((_, i) => (
  <div key={i} className='card' style={{ width: '150px', height: '100px' }}>
    <Skeleton height="100%" />
  </div>
))}
</div>